import React from 'react';
import { Select, MenuItem } from '@mui/material';
import useLanguagesHooks from './setLanguage-hooks';
import { ILanguages } from '../../Interfaces/componentTypes';
import styles from './languages.module.scss';

const Languages: React.FC = () => {
  const {
    containerRef,
    activeLangSrc,
    checkableLanguages,
    setAnchor,
    setActiveLangSrc,
    changeActiveLanguage,
  } = useLanguagesHooks();

  return (
    <div
      className={styles.language}
      ref={node => {
        setAnchor(node);
        containerRef.current = node;
      }}
    >
      <Select
        value={activeLangSrc}
        sx={{
          '&.MuiInputBase-root': {
            backgroundColor: 'transparent', 
            borderRadius: '0px', 
            padding:"3px"
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none !important', 
          },
          '& .MuiSelect-icon': {
            color: 'var(--icon-color)', 
          },
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center', 
            backgroundColor: 'transparent', 
          },
        }}
        onChange={(event) => {
          const selectedLanguage = checkableLanguages.find(
            (item) => item.icon === event.target.value
          );
          if (selectedLanguage) {
            setActiveLangSrc(selectedLanguage.icon);
            changeActiveLanguage(selectedLanguage.code);
          }
        }}
        displayEmpty
        className={styles.select}
        renderValue={(value) => (
          <img src={value as string} alt='langIcon' className={styles.languageItem} />
        )}
      >
        {checkableLanguages.map((item: ILanguages) => (
          <MenuItem value={item.icon} key={item.code}>
            <img
              src={item.icon}
              alt={item.code}
              className={styles.languageItem}
              style={{ marginRight: '8px', width: '24px', height: '24px' }}
            />
           
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default Languages